<template>
  <body class="joinUs-body">
    <div class="logo-wrapper">
      <img
        class="logo"
        src="../../../assets/sustainability/joinUs-logo.png"
        alt="join-us-logo"
      />
    </div>
    <div class="text-wrapper">
      <div class="title">
        Join Us in Making a <span class="title-span">Change</span>
      </div>
      <div class="text">
        We believe that sustainability is a shared responsibility.
        <br />
        <br />
        We invite brands across all industries to partner with Wecobi and join
        our mission to reduce environmental impact. Together, we can create a
        more sustainable future by transforming excess inventory into a force
        for good. Let’s work together to make a lasting difference<span
          class="text-span"
          >—one product at a time.</span
        >
      </div>
    </div>
  </body>
</template>

<script>
export default {
  name: "JoinUs",
  components: {},
};
</script>

<style scoped>
.joinUs-body {
  width: 100%;
  height: 358px;
  border-radius: 20px;
  position: relative;
  overflow: hidden;
  padding: 20px 20px 0px 80px;
  box-sizing: border-box;
}

.joinUs-body::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to left, #f98140 28%, #eb4dbf 72%);
  opacity: 0.7;
  z-index: -1;
}
.logo-wrapper {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  box-sizing: border-box;
}
.logo {
  width: 100px;
  height: 70px;
}
.text-wrapper {
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.title {
  font-size: 40px;
  font-weight: 600;
  line-height: 1.2;
  color: #000000;
}
.text {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  color: #000000;
  max-width: 1096px;
}
.title-span {
  color: #ffffff;
}
.text-span {
  font-weight: 700;
}
@media (max-width: 1280px) {
  .joinUs-body {
    height: 346px;
  }
  .title {
    font-size: 30px;
  }
  .text {
    max-width: 848px;
  }
}

@media (max-width: 1024px) {
  .joinUs-body {
    height: 355px;
  }
  .text {
    font-size: 14px;
    max-width: 592px;
  }
}
@media (max-width: 744px) {
  .joinUs-body {
    height: 376px;
    padding: 20px 20px 0px 50px;
  }
  .text {
    font-size: 14px;
    max-width: 477px;
  }
}
@media (max-width: 588px) {
  .joinUs-body {
    height: 320px;
    padding: 20px 20px 0px 50px;
  }
  .title {
    font-size: 25px;
  }
  .text {
    font-size: 12px;
    max-width: 455px;
  }
}
@media (max-width: 500px) {
  .joinUs-body {
    height: 369px;
    padding: 20px 30px 0px 30px;
  }
  .text-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .title {
    font-size: 25px;
  }
  .text {
    font-size: 12px;
    max-width: 455px;
  }
  .logo {
    width: 75px;
    height: 53px;
  }
}
</style>
